import React from 'react'
import Spinner from '../base-components/Spinner'

interface LoadingPageProps {
  text?: string
}

const LoadingPage: React.FC<LoadingPageProps> = ({ text = 'Laddar scener...' }) => {
  return (
    <div className='absolute flex h-full w-full items-center justify-center bg-gray-100 text-lg'>
      <div role='status' className='flex flex-col items-center justify-center'>
        <Spinner color='white' />
        <p className='my-2'>{text}</p>
      </div>
    </div>
  )
}

export default LoadingPage
